module.exports = __webpack_public_path__ + "img/product_49.50b6ab3.svg";